import Icon from "./Icon";

const DEFAULT_LANES = [
  "JAKARTA \u2192 SINGAPORE",
  "SURABAYA \u2192 ROTTERDAM",
  "BELAWAN \u2192 SHANGHAI",
  "JAKARTA \u2192 LOS ANGELES",
  "MAKASSAR \u2192 BUSAN",
];

export default function ManifestStrip({ lanes = DEFAULT_LANES, label = "ACTIVE LANES" }) {
  const track = [...lanes, ...lanes];
  return (
    <div className="manifest-strip" role="img" aria-label={`${label}: ${lanes.join(", ")}`}>
      <span className="manifest-strip__label">{label}</span>
      <div className="manifest-strip__track-wrap">
        <div className="manifest-strip__track">
          {track.map((lane, i) => (
            <span className="manifest-strip__item" key={i}>
              <Icon name="arrowRight" size={14} strokeWidth={2} />
              {lane}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
